import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import APPa from "../images/p.png";
import APP from "../images/p1.png";
import APP1 from "../images/p2.png";
import APP2 from "../images/p3.png";
import APP3 from "../images/len.jpg";

const Apps = () => {
  const contentBlocks = [
    {
      title: "BCS Everlasting Gospel",
      image: APP2,
      imageAlt: "BCS mobile apps ecosystem",
      overlayImage: APP1,
      overlayAlt: "Mobile ministry placeholder",
      paragraphs: [
        "The Everlasting Gospel App and Immortal Words App provide teaching-rich content, practical virtues, and structured spiritual engagement for daily growth.",
        "Together, they support users with accessible lessons, values-based reflection, and guided exposure to core Brotherhood teachings.",
      ],
    },
    {
      title: "BCS Hymnary",
      image: APP,
      imageAlt: "Everlasting Gospel mobile app",
      overlayImage: APP,
      overlayAlt: "Immortal Words mobile app",
      paragraphs: [
        "The BCS Hymnary provides comprehensive hymn access in an offline-ready format, ensuring continuity of worship where connectivity is limited.",
      ],
    },
    {
      title: "BCS EVA",
      image: APPa,
      imageAlt: "BCS Hymnary app",
      overlayImage: APPa,
      overlayAlt: "BCS EVA app",
      paragraphs: [
        "BCS EVA complements this foundation with conversational support designed to answer frequently asked questions about Brotherhood doctrine and identity.",
      ],
    },
    {
      title: "Learn Biakpan",
      image: APP3,
      imageAlt: "Learn Biakpan app",
      overlayImage: APP3,
      overlayAlt: "Future app placeholder",
      paragraphs: [
        "The Learn Biakpan app broadens educational access by helping users study language content at their own pace from any location.",
        "This learning direction supports cultural preservation, communication growth, and inclusive onboarding for members across generations.",
      ],
    },
  ];

  return (
    <motion.main
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="relative z-0 w-full bg-white text-slate-900"
    >
      <header className="relative z-0 pt-24 mt-24 md:pt-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
          <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
          <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
        </div>

        <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-4"
          >
            <span className="h-[1px] w-10 bg-blue-500" />
            <span className="text-blue-600 font-bold text-[10px] tracking-[0.45em] uppercase">
              Brotherhood of the Cross and Star
            </span>
            <span className="h-[1px] w-10 bg-blue-500" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="space-y-4"
          >
            <h1 className="text-5xl md:text-7xl font-black text-stone-900 tracking-tighter leading-none uppercase">
              Mobile <span className="text-blue-600 italic">Apps.</span>
            </h1>
            <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-3xl mx-auto">
              Mobile products for doctrine, worship, <br /> language learning,
              and practical spiritual engagement.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="px-6 md:px-20 py-16 md:py-28 space-y-28">
        {contentBlocks.map((block, index) => {
          const isOdd = index % 2 !== 0;
          const overlayAlignmentClass = isOdd ? "-left-10" : "-right-10";

          return (
            <article
              key={block.title}
              className="grid md:grid-cols-2 gap-14 md:gap-24 items-center"
            >
              <div className={isOdd ? "md:order-2" : ""}>
                <div className="relative">
                  <img
                    src={block.image}
                    alt={block.imageAlt}
                    className="w-full h-[300px] md:h-[420px] object-cover border border-slate-300"
                  />
                  <img
                    src={block.overlayImage}
                    alt={block.overlayAlt}
                    className={`hidden md:block absolute -bottom-10 ${overlayAlignmentClass} w-[46%] h-[180px] object-cover border-4 border-white shadow-xl`}
                  />
                </div>
              </div>

              <div className={`${isOdd ? "md:order-1" : ""} md:px-6 lg:px-10`}>
                <h2 className="text-2xl md:text-4xl leading-tight font-semibold text-slate-900">
                  {block.title}
                </h2>
                <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-slate-700">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
                {block.title === "BCS Hymnary" && (
                  <Link
                    to="/hymnary-privacy"
                    className="inline-flex mt-6 text-sm font-semibold text-blue-700 underline underline-offset-4"
                  >
                    BCS Hymnary Privacy Policy
                  </Link>
                )}
              </div>
            </article>
          );
        })}
      </section>
    </motion.main>
  );
};

export default Apps;
